import { FaSearch, FaShoppingBag, FaUser } from 'react-icons/fa';
import { useEffect, useState } from 'react';
import axios from 'axios';
import NotFound from '../shared/NotFound';
import { Link } from 'react-router-dom';

export default function Content() {
    const [data, setData] = useState<any[]>([]);
    const [pagination, setPagination] = useState<any>({});
    const [search, setSearch] = useState<string>('');
    const [experience, setCategory] = useState<string>('');
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [department, setDepartment] = useState<string>('');

    const getData = async (page: number = 1, search: string = '', experience: string = '', department: string = '') => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT}/job?page=${page}&search=${search}&experience=${experience}&department=${department}`
            );
            if (response && response.data && response.data.data) {
                setData(response.data.data.data);
                setPagination(response.data.data);
            } else {
                setData([]);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handlePageChange = async (page: number) => {
        setCurrentPage(page);
    };

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(event.target.value);
    };

    const handleExperienceClick = (experience: string) => {
        setCategory(experience);
    };

    const handleDepartmentClick = (department: string) => {
        setDepartment(department);
    }

    const handleClickSaveId = (id: string) => {
        localStorage.setItem('idJob', id);
    }

    useEffect(() => {
        getData(currentPage, search, experience, department);
    }, [currentPage, search, experience, department]);

    return (
        <>
            <div className="">
                <div className="max-w-[360px] md:max-w-[658px] px-4 md:px-0 mx-auto font-poppinsRegular">
                    <div className="flex justify-center sm:flex-row text-sm mt-5 mb-10">
                        <div className="flex space-x-5 mb-4 sm:mb-0 whitespace-nowrap justify-center">
                            <h1 className="text-2xl font-poppinsBold text-bprDarkBlue">LOWONGAN TERBARU</h1>
                        </div>
                    </div>
                    <div className="bg-white rounded-lg border p-4 relative">
                        <form action="" className="flex flex-col md:flex-row justify-between space-y-4 md:space-y-0 md:space-x-4">
                            <div className="relative w-full md:w-full">
                                <select
                                    onChange={(e) => handleExperienceClick(e.target.value)}
                                    name="" id="" className="pl-8 pr-2 py-2 border rounded-md w-full">
                                    <option value="">All</option>
                                    <option value="fresh graduate">Fresh Graduate</option>
                                    <option value="experienced">Experienced</option>
                                </select>
                                <FaUser className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500" />
                            </div>
                            <div className="relative w-full md:w-full">
                                <select onChange={(e) => handleDepartmentClick(e.target.value)} name="" id="" className="pl-8 pr-2 py-2 border rounded-md w-full">
                                    <option value="">All</option>
                                    <option value="IT">IT</option>
                                    <option value="HRD">HRD</option>
                                    <option value="Operasional">Operasional</option>
                                    <option value="Bisnis/Kredit">Bisnis/Kredit</option>
                                    <option value="Umum">Umum</option>
                                    <option value="Audit">Audit</option>
                                    <option value="Direksi">Direksi</option>
                                    <option value="Manajemen Resiko">Manajemen Resiko</option>
                                </select>
                                <FaShoppingBag className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500" />
                            </div>
                            <div className="relative w-full md:w-full">
                                <input
                                    type="text"
                                    value={search}
                                    onChange={handleSearchChange}
                                    name=""
                                    id=""
                                    placeholder="searching"
                                    className="pl-8 pr-2 py-2 border rounded-md w-full" />
                                <FaSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500" />
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="max-w-screen-2xl mx-auto pt-16 pb-1 p-4 md:p-5 lg:px-16 ">
                {data.length > 0 ? (
                    data.map((job) => (
                        <div key={job.id} className="flex flex-col md:flex-row items-center justify-between border rounded-lg p-4 mb-4 bg-white hover:shadow-md transition-shadow">
                            <div className="flex-1 font-semibold text-blue-900 mb-3 md:mb-0">
                                <span>{job.job_opening}</span>
                            </div>
                            <div className="flex-1 flex items-center space-x-3 mb-3 md:mb-0">
                                <FaUser />
                                <span>{job.experience}</span>
                            </div>
                            <div className="flex-1 flex items-center space-x-3 mb-3 md:mb-0">
                                <FaShoppingBag />
                                <span>{job.department}</span>
                            </div>
                            <Link to={`/detail-karir/${job.slug_title}`} onClick={() => handleClickSaveId(job.id)} className="w-full md:w-auto px-6 py-2 bg-blue-900 text-white rounded-md hover:bg-blue-800 transition-colors mt-3 md:mt-0">
                                Detail
                            </Link>
                        </div>
                    ))
                ) : (
                    <NotFound></NotFound>
                )}

                <div className="mt-10">
                    {pagination.total > 0 && (
                        <nav aria-label="Page navigation example" className="flex justify-end">
                            <ul className="inline-flex -space-x-px text-base h-10">
                                <li>
                                    <button
                                        onClick={() => handlePageChange(pagination.current_page - 1)}
                                        disabled={!pagination.prev_page_url}
                                        className="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700"
                                    >
                                        &laquo; Previous
                                    </button>
                                </li>
                                {pagination.links &&
                                    pagination.links.map((link: any, index: number) =>
                                        link.url && link.label !== '&laquo; Previous' && link.label !== 'Next &raquo;' ? (
                                            <li key={index}>
                                                <button
                                                    onClick={() =>
                                                        handlePageChange(Number(new URL(link.url).searchParams.get('page')))
                                                    }
                                                    className={`flex items-center justify-center px-4 h-10 leading-tight ${link.active ? 'text-blue-600 bg-blue-50' : 'text-gray-500 bg-white'
                                                        } border border-gray-300 hover:bg-gray-100 hover:text-gray-700`}
                                                >
                                                    {link.label}
                                                </button>
                                            </li>
                                        ) : null
                                    )}
                                <li>
                                    <button
                                        onClick={() => handlePageChange(pagination.current_page + 1)}
                                        disabled={!pagination.next_page_url}
                                        className="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700"
                                    >
                                        Next &raquo;
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    )}
                </div>
            </div>
        </>
    );
}
